import {
  compose, lifecycle, withHandlers, withState, withStateHandlers,
} from 'recompose';
import { remove } from 'ramda';
import { connect } from 'react-redux';

import { withRouter } from 'react-router';
import { closeModal, uploadTempFileRequest } from '../../../../state/ui/actions';
import { getModal, getTempFileUploadPending } from '../../../../state/ui/selectors';
import AttachFilesModal from './attachFilesModal';

const mapStateToProps = state => ({
  isOpen: getModal(state)('attachFilesChatModal'),
  isPending: getTempFileUploadPending(state),
});

const mapDispatchToProps = ({
  onCloseModal: () => closeModal('attachFilesChatModal'),
  uploadTempFile: uploadTempFileRequest,
});

const onChangeHandler = ({ setFilesList }) => (e) => {
  const filesList = Array.from(e.currentTarget.files);
  setFilesList(filesList);
};

const onUploadFilesHandler = ({
  filesList, uploadTempFile, setLoadingFiles, loadingFiles,
}) => () => {
  filesList.map((file) => {
    const formData = new FormData();
    formData.append('file', file);
    return uploadTempFile(formData, {
      callbacks: {
        success: ({ model }) => {
          setLoadingFiles(loadingFiles.concat(model));
        },
      },
    });
  });
};

const setLoadingFilesStateHandler = ({ loadingFiles }) => item => ({ loadingFiles: loadingFiles.concat(item) });

const onDeleteFileStateHandler = ({ loadingFiles }) => index => ({ loadingFiles: remove(index, 1, loadingFiles) });

const onSetTaskFilesHandler = ({
  loadingFiles, onCloseModal, setFilesList, onResetLoadingFiles,
  setAttachedFiles, attachedFiles,
}) => (e) => {
  e.preventDefault();
  setAttachedFiles({ ...loadingFiles, ...attachedFiles });
  onCloseModal();
  setFilesList([]);
  onResetLoadingFiles([]);
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withState('filesList', 'setFilesList', []),
  withStateHandlers(() => ({ loadingFiles: [] }), {
    onResetLoadingFiles: () => () => ({ loadingFiles: [] }),
    setLoadingFiles: setLoadingFilesStateHandler,
    onDeleteFile: onDeleteFileStateHandler,
  }),
  withHandlers({
    onChange: onChangeHandler,
    onUploadFiles: onUploadFilesHandler,
    onSetTaskFiles: onSetTaskFilesHandler,
  }),
  lifecycle({
    componentDidUpdate({ filesList }) {
      if (this.props.filesList !== filesList) {
        this.props.onUploadFiles();
      }
    },
  }),
);

export default enhance(AttachFilesModal);
